import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Page from "./page";
const contentful = require('contentful');

class App extends React.Component{
    state = {
        data: []
    }

    client = contentful.createClient({
        space: process.env.REACT_APP_CF_SPACE,
        accessToken: process.env.REACT_APP_CF_ACCESS_TOKEN
    })

    componentDidMount(){
        this.client.getEntries({
            content_type:'page',
            limit: 1000,
            include: 3
        }).then((response) => {
            this.setState({
                data: response.items
            })
        })
    }

    render(){
        return(
            <Router>
                <Routes>
                    {this.state.data.map((page, i) => (
                        <Route key={"route-"+i} path={page.fields.path} element={<Page fields={page.fields} />} />
                    ))}
                </Routes>
            </Router>
        )
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
serviceWorker.unregister();
